import { motion } from "framer-motion";

const MASTERS_IMAGE = "https://customer-assets.emergentagent.com/job_sweepstake-builder/artifacts/alvyjbcg_image.png";

export default function CaseStudy() {
  return (
    <section
      id="case-study"
      data-testid="case-study-section"
      className="py-10 lg:py-14 px-6 bg-[#F8FAFA] border-t border-[#1D3557]/5"
    >
      <div className="max-w-6xl mx-auto">
        <p className="font-body text-xs font-bold uppercase tracking-[0.2em] text-[#E63946] mb-3">
          Proven Results
        </p>
        <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl uppercase tracking-tight leading-none text-[#1D3557] mb-6 lg:mb-8">
          Already Delivering For Clubs
        </h2>

        <motion.div
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6 items-center"
        >
          {/* Screenshot */}
          <div className="border border-[#1D3557]/8 shadow-md overflow-hidden" data-testid="case-study-image">
            <img
              src={MASTERS_IMAGE}
              alt="Walterstown GFC Masters Sweepstake 2026 landing page"
              className="w-full h-auto"
            />
          </div>

          {/* Details */}
          <div className="p-6 lg:p-8">
            <p className="font-body text-xs font-bold uppercase tracking-[0.2em] text-[#1D3557]/40 mb-2">
              Masters Sweepstake 2026
            </p>
            <h3 className="font-heading font-bold text-2xl tracking-tight text-[#1D3557] mb-4">
              Walterstown GFC, Co. Meath, Ireland
            </h3>

            <div className="flex items-baseline gap-2 mb-4">
              <span className="font-heading font-black text-4xl lg:text-5xl text-[#E63946]">€2,400</span>
              <span className="font-body text-sm text-[#1D3557]/40">raised in 3 weeks</span>
            </div>

            <div className="space-y-3 mb-4">
              <div className="flex items-start gap-2.5">
                <span className="font-body text-sm text-[#1D3557]/60">Entry fee: €10 per member</span>
              </div>
              <div className="flex items-start gap-2.5">
                <span className="font-body text-sm text-[#1D3557]/60">Format: Pick 4 Golfers</span>
              </div>
              <div className="flex items-start gap-2.5">
                <span className="font-body text-sm text-[#1D3557]/60">Setup cost: €249 — <strong className="text-[#1D3557]">almost 10x return</strong></span>
              </div>
            </div>

            <p className="font-body text-sm text-[#1D3557]/45 leading-relaxed">
              Walterstown GFC ran our Masters Sweepstake for 3 weeks and raised €2,400 net for their club. Members loved it.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
